import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import ApiService from '../../service/ApiService';
import GeneralUtils from '../../utilities/GeneralUtils';
import ApiUtils from '../../utilities/ApiUtils';
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';

const maxFileSize = 5242880
const acceptFile = ".pdf"
const uploadClass = "p-button-text pcn-dialog-file-upload-button"

const CompetitionJobWrittenExamEditDialog = (props) => {
    const [totalSize, setTotalSize] = useState(0);
    const [accept, setAccept] = useState(acceptFile);
    const [exam, setExam] = useState(null);
    const [examDateError, setExamDateError] = useState(false);
    const [examLocationError, setExamLocationError] = useState(false);
    const [uploadButtonClass, setUploadButtonClass] = useState(uploadClass);

    const toast = useRef(null);
    const fileUploadRef = useRef(null);

    useEffect(() => {
        setAccept(acceptFile)

        // console.log(props?.value );
        setExam({ ...props?.value , examDate: new Date(Date.parse(props?.value.examDate)) });
    }, [props]);

    const formValidate = (_exam = null) => {
        let harErrors = false;
        let validatedExam = _exam ? _exam : exam

        // console.log("validation: ", validatedExam);

        if (!validatedExam?.examDate) {
            setExamDateError(true)
            harErrors = true
        } else {
            setExamDateError(false)
        }

        if (!validatedExam?.examLocation || validatedExam?.examLocation.trim() === '') {
            setExamLocationError(true)
            harErrors = true
        } else {
            setExamLocationError(false)
        }

        return !harErrors;
    }

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
    };

    const roundedSize = (size) => {
        return (size / (1024 * 1024)).toFixed(2)
    }

    const _onBeforeUpload = (event) => {
        if (formValidate()) {
            event.formData.append('entityId', exam.competitionCalendar.id.toString());
            event.formData.append('deletePrevious', false);
            event.formData.append('examDate', exam.examDate);
            event.formData.append('examLocation', exam.examLocation);
        }
    };

    const _onBeforeSend = (event) => {
        if (true) {
            event.xhr.open('POST', ApiService.getBaseUrl() + '/competition/job/calendar/writtenTest', true);
            event.xhr.setRequestHeader('Authorization', 'Bearer ' + ApiService.getToken());
        }
    };

    const _onUpload = (event) => {
        if (typeof props.onUploadSuccess === 'function') {
            props.onUploadSuccess(JSON.parse(event.xhr.response));
        }
        hideDialog();
    };

    const _onError = (event) => {
        setTotalSize(0);

        if (typeof props.onUploadError === 'function') {
            let response = JSON.parse(event.xhr.response);
            props.onUploadError(ApiUtils.computeFileUploadErrorArray(response));
        }
    };

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    }

    const onErrorRemove = (file, callback) => {
        callback();
    }

    const _onClear = () => {
        setTotalSize(0);
    }

    const checkFileTypeError = (file) => {
        if (file.type !== "application/pdf") {
            return true
        }
        return false
    }

    const _onSelect = (event) => {
        let _totalSize = totalSize;
        let files = event.files;
        let _maxFileSize = maxFileSize
        let isError = false

        Object.keys(files).forEach((key) => {
            if (files[key].size && files[key].size <= _maxFileSize) {
                _totalSize += files[key].size || 0;
            }
            if (files[key]) {
                isError = checkFileTypeError(files[key])
                if (isError) {
                    _totalSize -= files[key].size || 0;
                }
            }
        });

        setTotalSize(_totalSize)
        if (isError) {
            toast?.current?.show({ severity: 'error', summary: translatedMessage("file.type.error"), life: 5000 });
        }

        let _class = uploadClass
        if (!formValidate()) {
            _class = _class + ' p-disabled'
        }
        setUploadButtonClass(_class)
    }

    const itemTemplate = (_file, props) => {
        if (checkFileTypeError(_file)) {
            onErrorRemove(_file, props.onRemove)
        }
        return (
            <div>
                <div className="flex flex-row align-items-center justify-content-between pl-1 pr-1" style={{ minHeight: '60px' }}>
                    <div className='text-align-left'>{_file.name}</div>
                    <div className='flex align-items-center text-align-right'>
                        <span className='mr-4'>{roundedSize(_file.size)} MB</span>
                        <Button type="button" icon="pi pi-times" onClick={() => onTemplateRemove(_file, props.onRemove)} />
                    </div>
                </div>
            </div>
        );
    };

    const headerTemplate = (options) => {
        // console.log("headerTemplate: ", options);
        const { className, chooseButton, cancelButton } = options;
        let uploadButton = options.uploadButton

        return (<>
            <div className='pcn-dialog-subtitle'>{translatedMessage('file.upload.fileTypes')} {translatedMessage("file.upload.accept.pdf")}</div>
            <div className='mt-1 pcn-dialog-subtitle'>
                {translatedMessage('file.upload.maxFileSize')} {roundedSize(maxFileSize)} MB
            </div>
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{roundedSize(totalSize)} MB</span>
                </div>
            </div>
        </>);
    };

    const formDialogFooter = () => {
        return (
            <>
                <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} style={{ marginRight: "160px" }} />
            </>
        )
    }

    const handleFormFieldChange = (data) => {
        let _targetField = data?.target?.id
        let _exam = { ...exam, [_targetField]: data.target.value }
        setExam({ ..._exam });

        let _class = uploadClass
        if (!formValidate(_exam)) {
            _class = _class + ' p-disabled'
        }
        setUploadButtonClass(_class)
    }

    const formDialogHeader = (_exam) => {
        let _status = _exam?.approved === null ? 'pending' : (_exam?.approved ? 'approved' : 'rejected')
        return (<>
            <div>{translatedMessage('competition.writtenTest.postpone')}</div>
            {_exam?.id &&
                <div className={`pill inline-block approve-status-${_status.toLowerCase()}`}>
                    {translatedMessage('competition.exam.postpone.' + _status)}
                </div>
            }
        </>)
    };

    const uploadOptions = { className: uploadButtonClass, icon: "pi pi-save" };

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props.visible}
                header={formDialogHeader(exam)}
                modal
                onHide={hideDialog}
                className="pcn-dialog p-fluid"
                footer={formDialogFooter}
            >
                <form id="writtenTest-form">
                    <div className='grid mb-4'>
                        <div className='col-12 sm:col-6'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <Calendar
                                        id="examDate"
                                        name="examDate"
                                        value={exam?.examDate}
                                        onChange={(e) => handleFormFieldChange(e)}
                                        dateFormat="dd-mm-yy"
                                        showTime
                                        hourFormat="24"
                                        stepMinute={10}
                                        onShow={() => { if (!exam?.examDate) { setExam({ ...exam, examDate: GeneralUtils.roundDateTimeHour(0) }) } }}
                                        className={classNames({ 'p-invalid': examDateError })}
                                        disabled={exam?.id}
                                    />
                                    <label htmlFor="examDate" className={classNames({ 'p-error': examDateError })}>
                                        {translatedMessage('competition.exam.dateHour')} *
                                    </label>
                                </span>
                            </div>
                            {examDateError && <small className="p-error text-align-left">{translatedMessage('form.error.competition.examDate.required')}</small>}
                        </div>

                        <div className='col-12 sm:col-6'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <InputText type="text" name="examLocation" id="examLocation"
                                        value={exam?.examLocation} onChange={(e) => handleFormFieldChange(e)}
                                        className={classNames({ 'p-invalid': examLocationError })}
                                        disabled={exam?.id}
                                    />
                                    <label htmlFor="examLocation" className={classNames({ 'p-error': examLocationError })}>
                                        {translatedMessage("competition.exam.location")} *
                                    </label>
                                </span>
                            </div>
                            {examLocationError && <small className="p-error text-align-left">{translatedMessage('form.error.competition.examLocation.required')}</small>}
                        </div>
                    </div>
                </form>

                <FileUpload
                    name="file"
                    ref={fileUploadRef}
                    url={"/competition/job/calendar/writtenTest"}
                    accept={accept}
                    maxFileSize={maxFileSize}
                    invalidFileSizeMessageDetail={""}
                    invalidFileSizeMessageSummary={translatedMessage("file.upload.maxFileSize.error")}
                    multiple={false}
                    itemTemplate={itemTemplate}
                    onSelect={_onSelect}
                    onBeforeUpload={_onBeforeUpload}
                    onBeforeSend={_onBeforeSend}
                    onUpload={_onUpload}
                    onError={_onError}
                    onClear={_onClear}
                    chooseLabel={translatedMessage('generic.file.choose')}
                    uploadLabel={translatedMessage('competition.writtenTest.postpone')}
                    uploadOptions={uploadOptions}
                    cancelLabel={translatedMessage('generic.cancel')}
                    headerTemplate={headerTemplate}
                    disabled={exam?.id}
                />
            </Dialog>
        </>
    );
};

export default CompetitionJobWrittenExamEditDialog;